import { Title, Flex, Button } from '@mantine/core';
import { modals } from '@mantine/modals';

import {
  ConversionPairsTable,
  CreateConversionPairForm,
  useGetConversionPairs,
} from '@/modules/conversion-pairs';

export const ConversionPairs = () => {
  const {
    data,
    isLoading,
  } = useGetConversionPairs();

  const openCreateModal = () => modals.open({
    title: 'Добавление торговой пары',
    centered: true,
    children: (
      <CreateConversionPairForm
        onClose={modals.closeAll}
      />
    ),
  });

  return (
    <>
      <Flex justify="space-between" align="center" w="100%" mb={10}>
        <Title order={4}>Торговые пары</Title>

        <Button
          variant="filled"
          onClick={openCreateModal}
        >
          Создать
        </Button>
      </Flex>

      <ConversionPairsTable
        items={data || []}
        isLoading={isLoading}
      />
    </>
  );
};
